/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-01-16 11:51:42
 *
 *******************************************************/
//@flow

import _ from 'lodash';
import React from 'react';
import { Button, Tooltip } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { EditMajor } from '@shopify/polaris-icons';
import StrategyDetail from './strategy-detail';
import { routes } from 'src/routes';

type Props = {
  appLanguage: string,
  optionsList: Array<Object>,
  moneyFormat: string,
  merchandising: Array<Object>,
  history: any
};
type ComposedProps = Props & WithI18nProps;

// Render component
const MerchandisingPreview = (props: ComposedProps) => {
  const { i18n, appLanguage, optionsList, moneyFormat, merchandising = [], history } = props;
  if (merchandising.length <= 0) return null;

  // Sort consequences in the order of Pin - Boost - Demote - Hide
  const sortByTypeStrategy = (strategies: Array<Object>) => {
    const objPosition = {
      pin: 1,
      boost: 2,
      demote: 3,
      hide: 4,
      filter: 5
    };
    strategies.sort((a, b) => {
      const positionA = objPosition[a.type];
      const positionB = objPosition[b.type];
      return positionA - positionB;
    });
  };
  const getSummaryList = strategies => {
    // Render list button type of strategy by ruleType

    sortByTypeStrategy(strategies);
    return _.map(strategies, (strategy, index) => {
      return (
        <StrategyDetail
          key={`strategy-preview-${index}`}
          strategy={strategy}
          index={index}
          appLanguage={appLanguage}
          optionsList={optionsList}
          moneyFormat={moneyFormat}
          ruleType={'search'}
        />
      );
    });
  };

  return (
    <>
      <tr className="Polaris-DataTable__TableRow--outline">
        {[1, 2, 3, 4].map(emptyRow => (
          <td key={`empty-row-0${emptyRow}`} className="Polaris-DataTable__Cell" />
        ))}
      </tr>
      {merchandising.map((rule, indexRule) => (
        <tr
          className="Polaris-DataTable__TableRow Polaris-DataTable__TableRow--merchandising"
          key={'merchandising-preview-feature' + indexRule}>
          {/* Status */}
          {indexRule === 0 ? (
            <td className="Polaris-DataTable__Cell">
              <p className="category category-merchandising">
                {i18n.translate('AdminHTML.TestYourSearch.Table.Category.merchandising')}
              </p>
            </td>
          ) : (
            <td />
          )}

          <td className={`${indexRule === 0 ? 'Polaris-DataTable__Cell' : ''}`}>
            {i18n.translate(
              `AdminHTML.TestYourSearch.Table.Feature.${
                rule.queriesType === 'all' ? 'allSearchTerm' : 'specificSearchTerm'
              }`
            )}
          </td>
          <td className={`${indexRule === 0 ? 'Polaris-DataTable__Cell' : ''}`}>
            {getSummaryList(rule.strategies)}
          </td>
          <td
            className={`${
              indexRule === 0 ? 'Polaris-DataTable__Cell' : ''
            } Polaris-DataTable__Cell--action`}>
            <Tooltip
              content={i18n.translate('AdminHTML.TestYourSearch.Table.editTooltip')}
              preferredPosition="above">
              <Button
                size="slim"
                plain
                icon={EditMajor}
                onClick={() => history.push(routes.merchandising.edit(rule.id))}
              />
            </Tooltip>
          </td>
        </tr>
      ))}
      <tr style={{ height: '20px' }} />
    </>
  );
};

export default withI18n()(MerchandisingPreview);
